module.exports = __webpack_public_path__ + "statics/media/aspire-logo_white.60716aa4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/aspire-logo/aspire-logo_white.svg
// module id = 1215
// module chunks = 138